import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import SupplierForSelect from '../entities/suppliers/supplier-for-select'
interface SupplierState extends ListState<SupplierForSelect> {
}
class SupplierModule extends ListModule<SupplierState, any, SupplierForSelect>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SupplierForSelect>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<SupplierState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/Supplier/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<SupplierForSelect>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async searchSupplierForSelect(context:ActionContext<SupplierState,any>,payload:any){
            const {data:{result} }  =await Ajax.get('/api/services/app/Supplier/SearchSupplierForSelect/'+payload.data.clientCode+'/'+payload.data.keyWord);
            return result.items  as SupplierForSelect[];
        }
    };
    mutations = {
        setCurrentPage(state: SupplierState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SupplierState, pagesize: number) {
            state.pageSize = pagesize;
        }
       
    }
}
const supplierModule = new SupplierModule();
export default supplierModule;